<div class="flex-column flex-1 gap">
    <app-switch-input
        id="showCompleted"
        label="userTasks.filter.showCompleted"
        [form]="formFilter"
        class="w-18rem font-bold"
    ></app-switch-input>

    <div class="flex-column gap tasks-wrapper">
        <app-card class="active-tasks-container flex-1">
            <ng-template #header>
                <div class="flex-column gap-small">
                    <div class="textSubheader">{{ 'userTasks.title.actualList' | translate }}</div>
                    <div class="flex gap pt-2">
                        <app-text-input
                            [form]="form"
                            id="newTask"
                            class="w-full"
                            label="userTasks.newTask"
                            (keyup.enter)="addTask($event)"
                        ></app-text-input>
                        <app-button
                            icon="pi-plus"
                            [disabled]="!newTask()"
                            (clickEvent)="addTask()"
                        ></app-button>
                    </div>
                    <p-divider/>
                </div>
            </ng-template>
            <ng-template #content>
                <app-user-task-list [completed]="false" [folderId]="folderId()"></app-user-task-list>
            </ng-template>
        </app-card>

        @if (formFilter.value.showCompleted) {
            <app-card class="flex-1" [title]="'userTasks.title.completed'">
                <ng-template #content>
                    <app-user-task-list [completed]="true" [folderId]="folderId()"></app-user-task-list>
                </ng-template>
            </app-card>
        }
    </div>
</div>
